import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=be4ef060&scoped=true&"
import script from "./PlusButton.vue?vue&type=script&lang=js&"
export * from "./PlusButton.vue?vue&type=script&lang=js&"
import style0 from "./PlusButton.vue?vue&type=style&index=0&id=be4ef060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ef060",
  null
  
)

export default component.exports